import React, { useState, useEffect } from "react";
import axios from "axios";

const Legenda = () => {
    const [markers, setMarkers] = useState([]);

    useEffect(() => {
        const loadMarkers = async () => {
            const cachedMarkers = localStorage.getItem("markers");
            if (cachedMarkers) {
                setMarkers(JSON.parse(cachedMarkers));
                return;
            }

            try {
                const response = await axios.get(route("building-markers"));
                if (response.status === 200) {
                    setMarkers(response.data);
                }
            } catch (error) {
                console.error("Erro ao carregar marcadores:", error);
            }
        };

        loadMarkers();
    }, []);

    return (
        <table className="table table-striped table-condensed legenda-mapa">
            <thead>
                <tr>
                    <th colSpan="2" style={{ paddingBottom: 7 }}>
                        <span
                            className="font-weight-bold text-center"
                            style={{ color: 'rgb(0, 72, 14)', fontSize: 16 }}
                        >
                            EMPREENDIMENTOS
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                {markers.length === 0 ? (
                    <tr>
                        <td colSpan="2" className="text-muted text-center">
                            Nenhum empreendimento encontrado.
                        </td>
                    </tr>
                ) : (
                    markers.map((marker, index) => {
                        const uniqueKey = marker.id || `${marker.tipo}-${marker.status}-${index}`;

                        return (
                            <tr key={uniqueKey}>
                                <td>
                                    <img src={marker.icon} alt={marker.tipo} />
                                </td>
                                <td>{`${marker.tipo} ${marker.padrao} ${marker.status}`}</td>
                            </tr>
                        );
                    })
                )}
            </tbody>
        </table>
    );
};

export default Legenda;
